(function () {
  'use strict';

  function initPack4(root) {
    var form = root.querySelector('.hm-pack4__form');
    var dataEl = root.querySelector('[data-pack4-variant-data]');
    if (!form || !dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    var variants = data.variants || [];
    if (!variants.length) return;

    var variantId = form.querySelector('[data-pack4-variant-id]');
    var optionInputs = Array.prototype.slice.call(
      form.querySelectorAll('[data-pack4-option]')
    );
    var price = root.querySelector('[data-pack4-price]');
    var compare = root.querySelector('[data-pack4-compare]');
    var compareLabel = root.querySelector('[data-pack4-compare-label]');
    var availability = root.querySelector('[data-pack4-availability]');
    var addButton = form.querySelector('[data-pack4-add]');
    var addLabel = form.querySelector('[data-pack4-add-label]');
    var sticky = root.querySelector('[data-pack4-sticky]');
    var stickyPrice = root.querySelector('[data-pack4-sticky-price]');
    var stickyLabel = root.querySelector('[data-pack4-sticky-label]');
    var quantity = form.querySelector('[data-pack4-quantity]');
    var reducedMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var galleryController = null;

    if (!variantId) return;

    function selectedOptions() {
      var selected = {};

      optionInputs.forEach(function (input) {
        if (input.checked) {
          selected[Number(input.dataset.optionPosition)] = input.value;
        }
      });

      return Object.keys(selected)
        .sort(function (a, b) {
          return Number(a) - Number(b);
        })
        .map(function (position) {
          return selected[position];
        });
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        return (
          variant.options.length === options.length &&
          variant.options.every(function (value, index) {
            return value === options[index];
          })
        );
      });
    }

    function normaliseQuantity(rule) {
      if (!quantity) return;

      var min = Math.max(1, Number(rule.min) || 1);
      var increment = Math.max(1, Number(rule.increment) || 1);
      var max = rule.max == null ? Infinity : Number(rule.max);
      var current = Math.max(min, Number(quantity.value) || min);

      current =
        min +
        Math.ceil((current - min) / increment) * increment;

      if (Number.isFinite(max)) {
        current = Math.min(max, current);
      }

      quantity.min = String(min);
      quantity.step = String(increment);

      if (Number.isFinite(max)) {
        quantity.max = String(max);
      } else {
        quantity.removeAttribute('max');
      }

      quantity.value = String(current);
    }

    function updateGallery(variant) {
      if (!variant.featuredMediaId) return;

      var gallery = root.querySelector('[data-pack4-gallery]');
      var track =
        gallery && gallery.querySelector('[data-pack4-track]');

      var slides = track
        ? Array.prototype.slice.call(
            track.querySelectorAll('[data-pack4-slide]')
          )
        : [];

      var index = slides.findIndex(function (slide) {
        return (
          slide.dataset.mediaId ===
          String(variant.featuredMediaId)
        );
      });

      if (index < 0) return;

      if (galleryController) {
        galleryController.goTo(index);
        return;
      }

      if (track) {
        var trackRect = track.getBoundingClientRect();
        var slideRect = slides[index].getBoundingClientRect();

        track.scrollTo({
          left:
            track.scrollLeft +
            slideRect.left -
            trackRect.left,
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      }

      syncGalleryControls(index, slides);
    }

    function syncGalleryControls(index, slides) {
      var gallery = root.querySelector('[data-pack4-gallery]');
      if (!gallery) return;

      var thumbs = gallery.querySelectorAll(
        '[data-pack4-thumbnail]'
      );

      thumbs.forEach(function (thumb, thumbIndex) {
        thumb.classList.toggle(
          'is-active',
          thumbIndex === index
        );

        thumb.setAttribute(
          'aria-pressed',
          thumbIndex === index ? 'true' : 'false'
        );
      });

      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle(
          'is-active',
          slideIndex === index
        );
      });

      var previous = gallery.querySelector(
        '[data-pack4-previous]'
      );
      var next = gallery.querySelector(
        '[data-pack4-next]'
      );

      if (previous) previous.disabled = index <= 0;
      if (next) next.disabled = index >= slides.length - 1;
    }

    function setAvailability(isAvailable, message) {
      if (availability) {
        availability.textContent = isAvailable
          ? ''
          : message || 'This size is currently unavailable.';

        availability.hidden = !!isAvailable;
      }

      if (addButton) {
        addButton.disabled = !isAvailable;
      }

      if (addLabel) {
        addLabel.textContent = isAvailable
          ? 'Add bundle to cart'
          : 'Unavailable';
      }

      if (sticky) {
        sticky.disabled = !isAvailable;
      }

      if (stickyLabel) {
        stickyLabel.textContent = isAvailable
          ? 'Add bundle to cart'
          : 'Unavailable';
      }
    }

    function applyVariant(variant) {
      if (!variant) {
        variantId.value = '';

        setAvailability(
          false,
          'This option combination is unavailable.'
        );

        return;
      }

      variantId.value = variant.id;

      if (price) {
        price.textContent = variant.price;
      }

      if (stickyPrice) {
        stickyPrice.textContent = variant.price;
      }

      var hasCompare = Boolean(variant.compareAtPrice);

      if (compare) {
        compare.textContent = hasCompare
          ? variant.compareAtPrice
          : '';

        compare.hidden = !hasCompare;
      }

      if (compareLabel) {
        compareLabel.hidden = !hasCompare;
      }

      normaliseQuantity(variant.quantityRule || {});
      setAvailability(variant.available);
      updateGallery(variant);

      if (
        window.history &&
        window.history.replaceState
      ) {
        var url = new URL(window.location.href);

        url.searchParams.set(
          'variant',
          variant.id
        );

        window.history.replaceState({}, '', url);
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        applyVariant(
          findVariant(selectedOptions())
        );
      });
    });

    var initialVariant = variants.find(function (variant) {
      return (
        String(variant.id) ===
        String(variantId.value)
      );
    });

    if (initialVariant) {
      normaliseQuantity(
        initialVariant.quantityRule || {}
      );

      setAvailability(initialVariant.available);
    } else {
      variantId.value = '';

      setAvailability(
        false,
        'This option combination is unavailable.'
      );
    }

    var down = form.querySelector(
      '[data-pack4-quantity-down]'
    );
    var up = form.querySelector(
      '[data-pack4-quantity-up]'
    );

    if (quantity && down && up) {
      down.addEventListener('click', function () {
        quantity.stepDown();

        quantity.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      });

      up.addEventListener('click', function () {
        quantity.stepUp();

        quantity.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      });

      quantity.addEventListener('change', function () {
        normaliseQuantity({
          min: quantity.min,
          max: quantity.max || null,
          increment: quantity.step
        });
      });
    }

    var gallery = root.querySelector(
      '[data-pack4-gallery]'
    );

    if (gallery) {
      var track = gallery.querySelector(
        '[data-pack4-track]'
      );

      var slides = track
        ? Array.prototype.slice.call(
            track.querySelectorAll('[data-pack4-slide]')
          )
        : [];

      var activeIndex = 0;

      function goTo(index) {
        if (!slides.length) return;

        activeIndex = Math.max(
          0,
          Math.min(slides.length - 1, index)
        );

        if (track) {
          var trackRect =
            track.getBoundingClientRect();

          var slideRect =
            slides[activeIndex].getBoundingClientRect();

          track.scrollTo({
            left:
              track.scrollLeft +
              slideRect.left -
              trackRect.left,
            behavior: reducedMotion ? 'auto' : 'smooth'
          });
        }

        syncGalleryControls(activeIndex, slides);
      }

      galleryController = {
        goTo: goTo
      };

      gallery
        .querySelectorAll('[data-pack4-thumbnail]')
        .forEach(function (button) {
          button.addEventListener('click', function () {
            goTo(
              Number(button.dataset.pack4Thumbnail)
            );
          });
        });

      var previous = gallery.querySelector(
        '[data-pack4-previous]'
      );

      var next = gallery.querySelector(
        '[data-pack4-next]'
      );

      if (previous) {
        previous.addEventListener('click', function () {
          goTo(activeIndex - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          goTo(activeIndex + 1);
        });
      }

      if (track) {
        var scrollFrame = 0;

        track.addEventListener(
          'scroll',
          function () {
            if (scrollFrame) return;

            scrollFrame = window.requestAnimationFrame(
              function () {
                scrollFrame = 0;

                var trackRect =
                  track.getBoundingClientRect();

                var center =
                  trackRect.left +
                  track.clientWidth / 2;

                var bestDistance = Infinity;

                slides.forEach(function (slide, index) {
                  var slideRect =
                    slide.getBoundingClientRect();

                  var distance = Math.abs(
                    slideRect.left +
                    slideRect.width / 2 -
                    center
                  );

                  if (distance < bestDistance) {
                    bestDistance = distance;
                    activeIndex = index;
                  }
                });

                syncGalleryControls(
                  activeIndex,
                  slides
                );
              }
            );
          },
          { passive: true }
        );
      }

      syncGalleryControls(0, slides);

      // MOBILE GALLERY CONTROLS

      var mobileGallery = window.matchMedia(
        '(max-width: 820px)'
      );

      var controlsTimer = null;

      gallery.classList.add(
        'is-pack4-interactive'
      );

      function hideGalleryControls() {
        gallery.classList.remove(
          'is-controls-visible'
        );
      }

      function showGalleryControls() {
        if (!mobileGallery.matches) return;

        gallery.classList.add(
          'is-controls-visible'
        );

        window.clearTimeout(controlsTimer);

        controlsTimer = window.setTimeout(
          hideGalleryControls,
          3000
        );
      }

      gallery.addEventListener(
        'pointerdown',
        function (event) {
          if (
            event.pointerType === 'touch' ||
            event.pointerType === 'pen'
          ) {
            showGalleryControls();
          }
        },
        { passive: true }
      );

      gallery.addEventListener(
        'touchmove',
        showGalleryControls,
        { passive: true }
      );

      gallery.addEventListener(
        'focusin',
        function () {
          window.clearTimeout(controlsTimer);
          showGalleryControls();
        }
      );

      gallery.addEventListener(
        'focusout',
        function () {
          window.clearTimeout(controlsTimer);

          controlsTimer = window.setTimeout(
            hideGalleryControls,
            3000
          );
        }
      );

      if (mobileGallery.addEventListener) {
        mobileGallery.addEventListener(
          'change',
          function () {
            window.clearTimeout(controlsTimer);
            hideGalleryControls();
          }
        );
      }
    }

    // STICKY ADD TO CART

    if (sticky) {
      var hero = root.querySelector(
        '[data-pack4-hero]'
      );

      if (
        'IntersectionObserver' in window &&
        hero
      ) {
        var heroObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              sticky.hidden =
                entry.isIntersecting ||
                entry.boundingClientRect.top >= 0;
            });
          },
          {
            rootMargin: '-120px 0px 0px 0px',
            threshold: 0
          }
        );

        heroObserver.observe(hero);
      }

      sticky.addEventListener('click', function () {
        if (sticky.disabled) return;

        var submitter = form.querySelector(
          '[data-pack4-add]'
        );

        if (
          typeof form.requestSubmit === 'function' &&
          submitter
        ) {
          form.requestSubmit(submitter);
        } else if (
          submitter &&
          !submitter.disabled
        ) {
          submitter.click();
        }
      });
    }

    // REDUCED MOTION SUPPORT

    if (
      !reducedMotion &&
      'IntersectionObserver' in window
    ) {
      var revealItems = root.querySelectorAll(
        '[data-pack-reveal]'
      );

      if (revealItems.length) {
        root.classList.add(
          'hm-pack4--motion'
        );

        var revealObserver = new IntersectionObserver(
          function (entries, observer) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add(
                  'is-visible'
                );

                observer.unobserve(
                  entry.target
                );
              }
            });
          },
          {
            threshold: 0.08
          }
        );

        revealItems.forEach(function (item) {
          revealObserver.observe(item);
        });
      }
    }
  }

  document
    .querySelectorAll('[data-hm-pack4]')
    .forEach(initPack4);
})();